import React, { useEffect, useRef, useState } from 'react'

const CAPTIONS = ['renku tau vietą…', 'ieškau kur nuvežti…', 'radau tau vietą…']

function RuleteAnimacija({ vieta, onBaigta }) {
  const svgRef = useRef(null)
  const [captionVisible, setCaptionVisible] = useState(false)
  const [caption, setCaption] = useState(CAPTIONS[0])

  useEffect(() => {
    if (!vieta || !svgRef.current) return

    const svg = svgRef.current
    const W = window.innerWidth
    const H = window.innerHeight
    const USER_X = W / 2
    const USER_Y = H * 0.5
    const ns = 'http://www.w3.org/2000/svg'
    const sleep = ms => new Promise(r => setTimeout(r, ms))
    function rand(a, b) { return Math.random() * (b - a) + a }
    function randInt(a, b) { return Math.floor(rand(a, b + 1)) }

    setCaption(CAPTIONS[randInt(0, CAPTIONS.length - 1)])
    setCaptionVisible(false)

    const initialPinCount = randInt(2, 3)
    const loadingPinCount = randInt(1, 2)
    const totalPins = initialPinCount + loadingPinCount
    const chosenIndex = randInt(0, totalPins - 1)

    const positions = []
    for (let i = 0; i < totalPins; i++) {
      let pos, attempts = 0
      do {
        const angle = rand(0, 2 * Math.PI)
        const dist = rand(130, 260)
        pos = {
          x: USER_X + Math.cos(angle) * dist,
          y: USER_Y + Math.sin(angle) * dist
        }
        attempts++
        const inBounds = pos.x > 60 && pos.x < W - 60 && pos.y > 80 && pos.y < H - 120
        const farEnough = positions.every(p => {
          const dx = p.x - pos.x, dy = p.y - pos.y
          return Math.sqrt(dx * dx + dy * dy) > 75
        })
        if (inBounds && farEnough) break
      } while (attempts < 35)
      positions.push(pos)
    }

    const chosen = positions[chosenIndex]

    // DEFS
    const defs = document.createElementNS(ns, 'defs')

    const uGrad = document.createElementNS(ns, 'radialGradient')
    uGrad.setAttribute('id', 'uGlow')
    ;[['0%','#E5A840','0.35'],['100%','#E5A840','0']].forEach(([o,c,op]) => {
      const s = document.createElementNS(ns, 'stop')
      s.setAttribute('offset', o); s.setAttribute('stop-color', c); s.setAttribute('stop-opacity', op)
      uGrad.appendChild(s)
    })
    defs.appendChild(uGrad)

    const pGrad = document.createElementNS(ns, 'radialGradient')
    pGrad.setAttribute('id', 'pGlow')
    ;[['0%','#E5A840','0.6'],['100%','#E5A840','0']].forEach(([o,c,op]) => {
      const s = document.createElementNS(ns, 'stop')
      s.setAttribute('offset', o); s.setAttribute('stop-color', c); s.setAttribute('stop-opacity', op)
      pGrad.appendChild(s)
    })
    defs.appendChild(pGrad)

    const mask = document.createElementNS(ns, 'mask')
    mask.setAttribute('id', 'rMask')
    const revealPath = document.createElementNS(ns, 'path')
    revealPath.setAttribute('stroke', 'white')
    revealPath.setAttribute('stroke-width', '10')
    revealPath.setAttribute('fill', 'none')
    revealPath.setAttribute('stroke-linecap', 'round')
    mask.appendChild(revealPath)
    defs.appendChild(mask)
    svg.appendChild(defs)

    // Vartotojo pin
    const uGroup = document.createElementNS(ns, 'g')
    uGroup.style.opacity = '0'
    uGroup.style.transition = 'opacity 600ms cubic-bezier(0.65,0,0.35,1)'

    const uGlowC = document.createElementNS(ns, 'circle')
    uGlowC.setAttribute('cx', USER_X); uGlowC.setAttribute('cy', USER_Y)
    uGlowC.setAttribute('r', '22'); uGlowC.setAttribute('fill', 'url(#uGlow)')

    const uDot = document.createElementNS(ns, 'circle')
    uDot.setAttribute('cx', USER_X); uDot.setAttribute('cy', USER_Y)
    uDot.setAttribute('r', '9'); uDot.setAttribute('fill', '#F0E8D5')
    uDot.setAttribute('stroke', '#E5A840'); uDot.setAttribute('stroke-width', '2.5')

    uGroup.appendChild(uGlowC); uGroup.appendChild(uDot)
    svg.appendChild(uGroup)

    // Path'ai
    const midX = (USER_X + chosen.x) / 2 + rand(-70, 70)
    const midY = (USER_Y + chosen.y) / 2 + rand(-50, 50)
    const pathD = `M ${USER_X} ${USER_Y} Q ${midX} ${midY} ${chosen.x} ${chosen.y}`

    const dashedPath = document.createElementNS(ns, 'path')
    dashedPath.setAttribute('d', pathD)
    dashedPath.setAttribute('stroke', '#E5A840')
    dashedPath.setAttribute('stroke-width', '2')
    dashedPath.setAttribute('fill', 'none')
    dashedPath.setAttribute('stroke-dasharray', '4 6')
    dashedPath.setAttribute('stroke-linecap', 'round')
    dashedPath.setAttribute('mask', 'url(#rMask)')
    dashedPath.style.opacity = '0'
    svg.appendChild(dashedPath)

    const solidPath = document.createElementNS(ns, 'path')
    solidPath.setAttribute('d', pathD)
    solidPath.setAttribute('stroke', '#E5A840')
    solidPath.setAttribute('stroke-width', '2.5')
    solidPath.setAttribute('fill', 'none')
    solidPath.setAttribute('stroke-linecap', 'round')
    solidPath.style.opacity = '0'
    svg.appendChild(solidPath)

    revealPath.setAttribute('d', pathD)

    // Pin'ai
    function addPin(pos) {
      const g = document.createElementNS(ns, 'g')
      g.style.opacity = '0'
      g.style.transition = 'opacity 500ms cubic-bezier(0.65,0,0.35,1)'

      const glowC = document.createElementNS(ns, 'circle')
      glowC.setAttribute('cx', pos.x); glowC.setAttribute('cy', pos.y)
      glowC.setAttribute('r', '0'); glowC.setAttribute('fill', 'url(#pGlow)')
      g.appendChild(glowC)

      const circle = document.createElementNS(ns, 'circle')
      circle.setAttribute('cx', pos.x); circle.setAttribute('cy', pos.y)
      circle.setAttribute('r', '8'); circle.setAttribute('fill', '#E5A840')
      circle.setAttribute('opacity', '0.5')
      circle.style.transition = 'r 700ms cubic-bezier(0.34,1.56,0.64,1), opacity 400ms ease'
      g.appendChild(circle)

      svg.appendChild(g)
      return { g, circle, glowC }
    }

    const pinGroups = positions.map(pos => addPin(pos))

    async function run() {
      // 1 — fonas atsiranda (600ms), nieko kito
      await sleep(700)

      // 2 — vartotojo pin atsiranda
      uGroup.style.opacity = '1'
      await sleep(600)

      // 3 — tekstas atsiranda
      setCaptionVisible(true)
      await sleep(400)

      // 4 — linija pradeda pieštis
      const pathLength = dashedPath.getTotalLength ? dashedPath.getTotalLength() : 500
      revealPath.style.strokeDasharray = `${pathLength}`
      revealPath.style.strokeDashoffset = `${pathLength}`
      revealPath.style.transition = 'none'
      dashedPath.style.opacity = '1'

      const drawDuration = 450 + loadingPinCount * 350 + 550

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          revealPath.style.transition = `stroke-dashoffset ${drawDuration}ms cubic-bezier(0.4,0,0.6,1)`
          revealPath.style.strokeDashoffset = '0'
        })
      })

      // 5 — pin'ai atsiranda staggered kol linija eina
      for (let i = 0; i < initialPinCount; i++) {
        await sleep(280)
        pinGroups[i].g.style.opacity = '1'
      }

      for (let i = 0; i < loadingPinCount; i++) {
        await sleep(420)
        pinGroups[initialPinCount + i].g.style.opacity = '1'
      }

      // Laukiam kol linija baigia
      const elapsed = initialPinCount * 280 + loadingPinCount * 420
      const remaining = drawDuration - elapsed
      if (remaining > 0) await sleep(remaining)

      // 6 — dashed → solid
      dashedPath.style.transition = 'opacity 400ms ease'
      solidPath.style.transition = 'opacity 400ms ease'
      dashedPath.style.opacity = '0'
      solidPath.style.opacity = '1'

      // 7 — glow + highlight chosen, kiti blėsta
      pinGroups.forEach(({ g, circle, glowC }, i) => {
        if (i !== chosenIndex) {
          g.style.transition = 'opacity 600ms ease'
          g.style.opacity = '0.1'
        } else {
          circle.setAttribute('r', '16')
          circle.setAttribute('opacity', '1')
          glowC.style.transition = 'r 280ms cubic-bezier(0.22,1,0.36,1)'
          glowC.setAttribute('r', Math.min(W, H) * 0.65 + '')
          setTimeout(() => {
            glowC.style.transition = 'opacity 450ms ease'
            glowC.style.opacity = '0'
          }, 180)
        }
      })

      if (navigator.vibrate) navigator.vibrate(40)

      // 8 — smooth perėjimas į rezultatą
      await sleep(1000)
      onBaigta()
    }

    run()
    return () => { while (svg.firstChild) svg.removeChild(svg.firstChild) }
  }, [vieta, onBaigta])

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 50,
      background: '#0A1310',
      animation: 'rulFadeIn 0.7s cubic-bezier(0.65,0,0.35,1) forwards'
    }}>
      <style>{`@keyframes rulFadeIn {
        0% { opacity: 0; }
        100% { opacity: 1; }
      }`}</style>
      <svg ref={svgRef} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }} />
      <p style={{
        position: 'absolute',
        bottom: '80px',
        left: 0,
        right: 0,
        textAlign: 'center',
        color: '#B0B8A8',
        fontSize: '15px',
        fontFamily: "'Lora', Georgia, serif",
        fontStyle: 'italic',
        letterSpacing: '0.02em',
        opacity: captionVisible ? 1 : 0,
        transition: 'opacity 0.5s ease',
        pointerEvents: 'none'
      }}>
        {caption}
      </p>
    </div>
  )
}

export default RuleteAnimacija
